import { $api } from '@service/RequestService';
import { useQuery } from 'react-query';

import { CustomFieldType } from '../models';

export function usePaymentCustomFields(enabled: boolean) {
  const { data, ...arg } = useQuery<{ paymentCustomFields: CustomFieldType[] }>(
    ['dashboard-v2-payment-custom-fields'],
    async () => {
      const { data } = await $api.get('/v1/payment/field');

      return { paymentCustomFields: data?.data };
    },
    {
      enabled,
      staleTime: Infinity,
      cacheTime: Infinity
    }
  );

  return { ...data, ...arg };
}
